<div class="container-fluid">
  <div class="page-title flex">
    <h5 class="float-left">{{'Discovery Job Settings' | translate}}</h5>
    <div>
      <button pButton type="button" label="{{'Run' | translate}}" icon="fa fa-play" class="ui-button-danger update" (click)="runDiscoveryJobInit()"
      [disabled]="(selectedDiscoveryJob == null || selectedDiscoveryJob.length === 0)"></button>
      <button pButton type="button" label="{{'Add Discovery Job' | translate}}" icon="fa fa-plus" class="ui-button-danger" (click)="showAddDialog()"></button>
    </div>
  </div>
  <p-table class="deviceTable pageAllOptions" [columns]="discoveryJobSettings_columns_cols" [value]="discoveryJobSettings" [rows]="10" [paginator]="true"
  [rowsPerPageOptions]="[10,20,{showAll:'All'}]" [scrollable]="true" [(selection)]="selectedDiscoveryJob" (onRowSelect)="onRowSelect($event)"
  (onRowUnselect)="onRowUnselect($event)">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th style="width: 40px">
          <!-- <p-tableHeaderCheckbox [disabled]="disableDisciveryCheckAllBoxFlag"></p-tableHeaderCheckbox> -->
        </th>
        <th style="width: 60px"></th>
        <th *ngFor="let col of columns; let i= index" [pSortableColumn]="col.field" [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
          {{col.header | translate}}
          <i *ngIf="i == 6" class="fa fa-info-circle" aria-hidden="true" pTooltip="{{'The time when the device was last discovered.' | translate}}" tooltipPosition="bottom"
            tooltipStyleClass="tooltips_gary"></i>
            <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowIndex="rowIndex" let-rowData let-columns="columns">
      <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="rowIndex">
        <td style="width: 40px">
          <p-tableCheckbox [value]="rowData" [index]="rowIndex" *ngIf="rowData.enableRun"></p-tableCheckbox>
        </td>
        <td style="width: 60px;text-align: center">
          <div class="flex crud" *ngIf="rowData.enableRun">
            <a class="editBtn" (click)="showEditDialog(rowData)">
              <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
            </a>
            <a class="delete" (click)="showConfirmDialog(rowData)" *ngIf="!rowData.disabledDelete">
              <i class="fa fa-trash" aria-hidden="true"></i>
            </a>
          </div>
        </td>
        <td style="width: 200px" class="col-nowrap">{{rowData.jobName}}</td>
        <td style="width: 200px" *ngIf="isMsp" class="break-word">{{rowData.company}}</td>
        <td style="width: 200px">{{rowData.gatewayStr}}</td>
        <td style="width: 250px" class="col-nowrap">{{rowData.startIpAddress}} - {{rowData.endIpAddress}}</td>
        <td style="width: 250px">{{rowData.snmpProfileStr}}</td>
        <td style="width: 150px" class="col-nowrap">{{rowData.device}}</td>
        <td style="width: 180px" class="col-nowrap">{{rowData.lastRuntime}}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="discoveryJobSettings_columns_cols.length">
          <div translate class="ui-emptymessage">No Data found</div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<div class="container-fluid" style="margin-top: 60px">
  <div class="page-title flex">
    <h5 class="float-left">{{'Discovered Device' | translate}}</h5>
    <div>
      <button pButton type="button" label="{{'Add to Cloud' | translate}}" icon="fa fa-plus" class="ui-button-danger update" (click)="checkAddToCloudDevice()"
      [disabled]="(selectedDiscoveredDevice == null || selectedDiscoveredDevice.length == 0 || clickrunDiscoveryJobFlag)"></button>
    </div>
  </div>
  <p-blockUI [target]="pnl" [blocked]="discoveryJobRuningFlag" class="loading-blockUI">
    <div class="loading">
      <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
      <p translate>Device Discovery in Progress</p>
    </div>
  </p-blockUI>
  <p-panel #pnl class="no-border" [showHeader]="false">
    <p-table class="deviceTable pageAllOptions" [columns]="discoveredDevice_columns_cols" [value]="discoveredDevice" [rows]="10" [paginator]="true"
    [rowsPerPageOptions]="[10,20,{showAll:'All'}]" [scrollable]="true" [(selection)]="selectedDiscoveredDevice" (onRowSelect)="onRowSelectDevice($event)"
    (onRowUnselect)="onRowUnselectDevice($event)" (onHeaderCheckboxToggle)="onHeaderCheckboxToggle($event)">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th style="width: 60px">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
            {{col.header | translate}}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowIndex="rowIndex" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="rowIndex">
          <td style="width: 60px">
            <p-tableCheckbox [value]="rowData" [index]="rowIndex"></p-tableCheckbox>
          </td>
          <td style="width: 250px" class="col-nowrap ellipsis">
            <input type="text" class="form-control pInputText" size="20" maxlength="20" [ngModel]="rowData.name" pInputText [disabled]="rowData.disabledCheckName">
          </td>
          <td style="width: 150px" class="col-nowrap">{{rowData.model}}</td>
          <td style="width: 150px" class="col-nowrap">{{rowData.brand}}</td>
          <td style="width: 150px" class="col-nowrap">{{rowData.category}}</td>
          <td style="width: 150px" class="col-nowrap">{{rowData.ipAddress}}</td>
          <td style="width: 200px">{{rowData.jobName}}</td>
          <td style="width: 200px" *ngIf="isMsp" class="break-word">{{rowData.company}}</td>
          <td style="width: 200px" class="col-nowrap">{{rowData.gateway}}</td>
          <td style="width: 200px" class="col-nowrap">{{rowData.snmp}}</td>
          <td style="width: 200px" class="col-nowrap">{{rowData.protocol}}</td>
          <td style="width: 200px" class="col-nowrap">{{rowData.serialNumber}}</td>
          <td style="width: 180px" class="col-nowrap">{{rowData.time}}</td>
          
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="discoveredDevice_columns_cols.length">
            <div translate class="ui-emptymessage">No Data found</div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-panel>
</div>

<!-- Attention -->
<p-dialog header="{{'Attention' | translate}}" [(visible)]="dialogType.addCloudAlert" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <p translate>Please name the device before adding to Cloud.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'OK' | translate}}" class="ui-button-danger" (click)="dialogType.addCloudAlert=false"></button>
  </ng-template>
</p-dialog>

<!-- Add -->
<p-dialog header="{{dialogInput.UpdateType | translate}}" [(visible)]="dialogType.addDiscoveryJob" [modal]="true" [style]="{'width': '450px'}"[baseZIndex]="10000" class="gatewayDialog accountSetting" (onHide)="closeAddDiscoveryJobDailog();">
  <div class="dialog-content">
    <div class="form-group" *ngIf="isMsp">
      <label translate>Company</label>
      <div class="select">
        <p-select [options]="companyOptions" [(ngModel)]="dialogInput.company" [style]="{'width':'100%'}" (onChange)="dailogFilter(true);" [disabled]="dialogInput.UpdateType === 'Edit Discovery Job'"
        placeholder="{{'Choose' | translate}}">
          <ng-template pTemplate="item" let-item>
            {{item.label | translate}}
          </ng-template>
          <ng-template pTemplate="selectedItem" let-item>
            {{item.label | translate}}
          </ng-template>
        </p-select>
      </div>
    </div>
    <div class="form-group">
      <label translate>Discovery Job Name</label>
      <input type="text" class="form-control pInputText" pInputText [(ngModel)]="dialogInput.jobName" (input)="checkJobName()">
    </div>
    <div class="form-group">
      <label translate>Gateway</label>
      <div class="select">
        <p-multiSelect [options]="gatewayOptions" [(ngModel)]="dialogInput.gateway" [baseZIndex]="10000" [disabled]="disableGateWayFlag" placeholder="{{'Choose' | translate}}">
          <ng-template let-item pTemplate="item">
            <span>{{item.label}}</span>
          </ng-template>
        </p-multiSelect>
      </div>
    </div>
    <div class="form-group">
      <label translate>SNMP Profile</label>
      <div class="select">
        <p-multiSelect [options]="profileOptions" [(ngModel)]="dialogInput.snmp" [baseZIndex]="10000" [disabled]="disableProfileFlag" appendTo="body" placeholder="{{'Choose' | translate}}">
          <ng-template let-item pTemplate="item">
            <span>{{item.label}}</span>
          </ng-template>
        </p-multiSelect>
      </div>
    </div>
    <div class="form-group">
      <label translate>Start IP address</label>
      <input type="text" size="30" class="form-control pInputText" [(ngModel)]="dialogInput.startIpAddress" (ngModelChange)="checkIpAdress(dialogInput.startIpAddress, 'start')" pInputText
      pattern="((^|\.)((25[0-5])|(2[0-4]\d)|(1\d\d)|([1-9]?\d))){4}$">
    </div>
    <div class="form-group">
      <label translate>End IP address</label>
      <input type="text" size="30" class="form-control pInputText" [(ngModel)]="dialogInput.endIpAddress" (ngModelChange)="checkIpAdress(dialogInput.endIpAddress, 'end')" pInputText
      pattern="((^|\.)((25[0-5])|(2[0-4]\d)|(1\d\d)|([1-9]?\d))){4}$">
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton  label="{{'Save' | translate}}" class="ui-button-danger"
    [disabled]="dialogInput.jobName === '' || jobNameDuplicate || !dialogInput.gateway || dialogInput.gateway.length === 0 || !dialogInput.startIpAddress || !ipAddressPattern.test(dialogInput.startIpAddress) ||
    !dialogInput.endIpAddress || !ipAddressPattern.test(dialogInput.endIpAddress) || !dialogInput.snmp || dialogInput.snmp.length === 0 || checkIpSaveFlag" (click)="saveDiscoveryJob();" ></button>
    <button type="button" pButton (click)="dialogType.addDiscoveryJob=false;" label="{{'Cancel' | translate}}" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- Confirm -->
<p-dialog header="{{'Confirm' | translate}}" [(visible)]="dialogType.stopDiscoveryJobConfirm" [modal]="true" [style]="{'width': '450px'}" [baseZIndex]="10000" class="ConfirmDialog">
  <div class="page-content-body">
    <p translate>Are you sure you want to stop the discovery process?</p>
  </div>
  <ng-template #footer>
    <div class="page-content-btn grid">
      <button type="button" pButton label="{{'Confirm' | translate}}" class="ui-button-danger" (click)="stopDiscoveryJob()"></button>
      <button type="button" pButton (click)="dialogType.stopDiscoveryJobConfirm=false" label="{{'Cancel' | translate}}" class="p-button-secondary"></button>
    </div>
  </ng-template>
</p-dialog>

<!-- Gateway Upgrade Warning -->
<p-dialog header="{{'Confirm' | translate}}" [(visible)]="dialogType.gatewayUpgradeWarning" [modal]="true" [style]="{'width': '450px'}" [baseZIndex]="10000" class="ConfirmDialog">
  <div class="page-content-body">
    <p translate>The following gateway is in update process. Please try again later.</p>
  </div>
  <ul class="alert alert-warning">
    <li *ngFor="let item of upgradeGatewayArray">
      <span>{{item}}</span>
    </li>
  </ul>
  <ng-template #footer>
    <div class="page-content-btn">
      <button type="button" pButton (click)="dialogType.gatewayUpgradeWarning=false" label="{{'OK' | translate}}" class="p-button-secondary"></button>
    </div>
  </ng-template>
</p-dialog>

<!-- Attention -->
<p-dialog header="{{'Attention' | translate}}" [(visible)]="dialogType.gatewayOfflineWarning" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="distributeDialog">
  <div class="dialog-content">
    <div class="content-info">
      <p style="padding-bottom: 10px;" translate>The following gateway is offline. Do you still want to proceed?</p>
    </div>
    <ul class="alert alert-warning">
      <li *ngFor="let item of offlineGatewayArray">
        <span>{{item}}</span>
      </li>
    </ul>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" class="ui-button-danger"(click)="checkAttention()"></button>
    <button type="button" pButton (click)="dialogType.gatewayOfflineWarning=false;selectedDiscoveryJob=null" label="{{'Cancel' | translate}}"class="p-button-secondary"></button>
  </ng-template>
</p-dialog>


<!-- Confirm -->
<p-dialog header="{{'Confirm' | translate}}" [(visible)]="displayConfirmDialog" [modal]="true" [style]="{'width': '450px'}" [baseZIndex]="10000" class="ConfirmDialog">
  <div class="page-content-body">
    <p translate>Do you really want to delete this record?</p>
  </div>
  <ng-template #footer>
    <div class="page-content-btn grid">
      <button type="button" pButton label="{{'Confirm' | translate}}" class="ui-button-danger"(click)="deleteDiscoveryJob()"></button>
      <button type="button" pButton (click)="displayConfirmDialog=false" label="{{'Cancel' | translate}}"class="p-button-secondary"></button>
    </div>
  </ng-template>
</p-dialog>

<!-- Attention -->
<p-dialog header="{{'Attention' | translate}}" [(visible)]="dialogType.gatewayOfflineWarning" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="distributeDialog">
  <div class="dialog-content">
    <div class="content-info">
      <p style="padding-bottom: 10px;" translate>The following gateway is offline. Do you still want to proceed?</p>
    </div>
    <ul class="alert alert-warning">
      <li *ngFor="let item of offlineGatewayArray">
        <span>{{item}}</span>
      </li>
    </ul>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" class="ui-button-danger"(click)="checkAttention()"></button>
    <button type="button" pButton (click)="dialogType.gatewayOfflineWarning=false;selectedDiscoveryJob=null" label="{{'Cancel' | translate}}"class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- CheckDuplicateDeviceSn -->
<p-dialog header="{{'Add To Cloud' | translate}}" [(visible)]="displayDuplicateDeviceSn" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="distributeDialog">
  <div class="dialog-content">
    <div class="content-info">
      <p style="padding-bottom: 10px;" translate>The following devices cannot be added due to repeated selections. Please choose the settings you want to use for the device, and then proceed to join.</p>
    </div>
    <ul class="alert alert-warning">
      <pre>{{duplicateDeviceIp}}</pre>
    </ul>
    <div class="content-info" *ngIf="!cannotAddToCloud">
      <p style="padding-bottom: 10px;" translate>Did the other devices help you join first?</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" class="ui-button-danger" (click)="addToCloud()" *ngIf="!cannotAddToCloud else cannotAdd"></button>
    <button type="button" pButton (click)="displayDuplicateDeviceSn=false;" label="{{'Later' | translate}}"class="p-button-secondary" *ngIf="!cannotAddToCloud"></button>
    <ng-template #cannotAdd>
      <button type="button" pButton (click)="displayDuplicateDeviceSn=false;" label="{{'Confirm' | translate}}" class="ui-button-danger"></button>
    </ng-template>
  </ng-template>
</p-dialog>

<div class="jobs-sidebar" id="DiscoveryJobsRunning" [ngClass]="{'show': deviceDiscoveryProgress}">
  <button (click)="toggleDiscoveryJobsRunning(false)" class="btn btn-sm toggleBtn">
    <i class="fa fa-caret-right"></i>
  </button>
  <div class="main-title">
    <h5 title="{{'Discovery jobs running progress' | translate}}">{{'Discovery jobs running progress' | translate}}</h5>
    <div class="note">
      {{'The device discovery process may take several minutes or even hours, depending on the set conditions. You can safely leave this page, as the discovery process will continue to run in the background.' | translate}}
    </div>
    <hr>
  </div>
  <div class="gradient-mask" *ngIf="this.scrollTopNumer > 30"></div>
  <p-scrollPanel #scrollPanel [style]="{width: '100%', height: scrollPanelHeight + 'px'}">
    <div class="jobs-content">
      <div class="jobs">
        <ng-container *ngFor="let item of runDiscoveryJobList">
          <div class="list" *ngIf="!item.disabled">
            <div class="flex align-items-center" [ngClass]="{'padding-bottom-none': item.status === 0}">
              <div class="title flex">
                <div class="icon">
                  <!-- <i class="fa fa-refresh fa-2x" *ngIf="item.status === 0" ></i> -->
                  <span class="fa-stack" *ngIf="item.status === 0">
                    <i class="fa fa-circle fa-2x"></i>
                    <i class="fa fa-refresh fa-stack-1x fa-inverse fa-spin"></i>
                  </span>
                  <i class="fa fa-check-circle normal fa-2x" *ngIf="item.status === 1"></i>
                  <i class="fa fa-exclamation-circle warning fa-2x" *ngIf="item.status === 2"></i>
                </div>
                <div class="title-content">
                  <label>{{item.Name}}</label>
                  <span class="flex flex-start">
                    <small *ngIf="item.status === 0" class="num">{{ (item.percentage || 0) | number:'1.0-0' }} % </small>
                    <small *ngIf="item.status === 0" > / {{'Device Discovery in Progress' | translate}}</small>
                    <small *ngIf="item.status === 1" >{{'Device Discovery Complete' | translate}}</small>
                    <small *ngIf="item.status === 2" >{{'The discovery job has been aborted. Please check the status of the Gateway ({GatewayName}) connection. If you stopped it manually, you may disregard this message.' | translate: {GatewayName: item.gatewayname} }}
                    </small>
                  </span>
                </div>
              </div>
              <div class="value">
                <button *ngIf="item.status === 0" pButton type="button" icon="fa fa-times" class="p-button-gray" (click)="showStopDiscoveryJobConfirm(item);"></button>
                <button *ngIf="item.status === 1 || item.status === 2" pButton type="button" icon="fa fa-check" class="p-button-gray" (click)="confirmDiscoveryJob(item);"></button>
              </div>
            </div>
            <p-progressBar *ngIf="item.status === 0" [value]="item.percentage | number:'1.0-0'" [showValue]="false"></p-progressBar>
          </div>
        </ng-container>
        <div *ngIf="runDiscoveryJobList.length === 0">
          <div class="note">
            {{'No Job Running' | translate}}
          </div>
        </div>
      </div>
    </div>

  </p-scrollPanel>
</div>
<app-dialog></app-dialog>
